import { createStore } from 'zustand/vanilla';
export const ChainClients = createStore(() => ({}));
//# sourceMappingURL=store.js.map